import PropertyCard from "../display/property-card";
const ProductListingV1 = ({ propertyData }) => {
	return (
		<div>
			<div className="ltn__product-slider-area ltn__product-gutter pt-115 pb-70">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="section-title-area ltn__section-title-2--- text-center">
								<h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
									Properti
								</h6>
								<h1 className="section-title">
									Baru ditambahkan
								</h1>
							</div>
						</div>
					</div>
					<div className="product-listing-horizontal">
						<div className="row">
							{propertyData.map((property, index) => (
								<PropertyCard property={property} key={index} />
							))}
						</div>

					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductListingV1;
